<template>
  <div :class="[{ 'chat': true }, projectId]" :style="customizedStyle">
    <div v-html="html"></div>
    <beautiful-chat :isHistoryMode="isHistoryMode" :appModule_conversation_id="appModule_conversation_id"
      :gameNumber="gameNumber" :alwaysScrollToBottom="alwaysScrollToBottom" :close="closeChat" :device="device"
      :handle_logoutTimer="handle_logoutTimer" :showHistoryMode="showHistoryMode"
      :handle_show_activebtnPage="handle_show_activebtnPage" :handle_show_noconnection="handle_show_noconnection"
      :isOpen="isChatOpen" :isMobile="isMobile" :isApp="isApp" :latData="latData" :messageList="showClientMessages"
      :minify="minifyChat" :messageStyling="messageStyling" @tag-clicked="tagClicked"
      :noconnectionImageUrl="noconnectionImageUrl" :noconnection_icon_refresh="noconnection_icon_refresh"
      :noconnectionType="noconnectionType" :newMessagesCount="newMessagesCount" :onMessageWasSent="onMessageWasSent"
      :open="openChat" :projectId="projectId" :projectTitleName="projectTitleName" :participants="participants"
      :returnJSONtoMobile="returnJSONtoMobile" :showEmoji="false" :showFile="false" :showWelcome="showWelcome"
      :announcements="announcements" :show_activebtnPage="show_activebtnPage" :show_noconnection="show_noconnection"
      :showTypingIndicator="showTypingIndicator" :streamingIn="streamingIn" :titleImageUrl="titleImageUrl"
      :showHistoryBar="showHistoryBar" :welcomBg="welcomBg" @handle_show-welcome="handle_showWelcome"
      @close-game-popup="closeGamePopup" />
  </div>
</template>

<script>
import $ from 'jquery'
import { uuid } from 'vue-uuid'
import { postMessage } from '../js/postMessage.js'
import { mobileClose } from '../js/mobileClose.js'
import { handle_pinch_hand } from '../js/handle_pinch_hand.js'
import { getLatitudeAndLongitude } from '../js/getLatitudeAndLongitude.js'
import { getPositionPrompt } from '../js/getPositionPrompt.js'
import { customMessage } from '../js/customMessage.js'
import BeautifulChat from "@/components/beautiful-chat/Launcher"
import { chats, getChats, getUserHistoryChats, sessionOver, getAnnouncement, changeCallHumanStatus } from '@/api/chat.js'

export default {
  name: "app",
  components: {
    BeautifulChat
  },
  // inject: ['isMobile'],
  props: {
    projectId: {
      type: String,
      default: ''
    },
    isApp: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      default: ''
    },
    projectTitleName: {
      type: String,
      default: () => ''
    },
    participants: {
      type: Array,
      required: true
    },
    titleImageUrl: {
      type: String,
      default: () => ''
    },
    noconnectionImageUrl: {
      type: String,
      default: () => ''
    },
    noconnection_icon_refresh: {
      type: String,
      default: () => ''
    },
    welcomBg: {
      type: String,
      default: () => ''
    },
    backgroundImage: {
      type: String,
      default: () => ''
    },
    eipToken: {
      type: String,
      default: () => ''
    },
    userId: {
      type: String,
      default: () => ''
    },
    appModule_conversation_id: {
      type: String,
      default: () => ''
    },
    platform_param: {
      type: String,
      default: () => ''
    },
    latData: {
      type: String,
      default: () => ''
    },
  },
  data() {
    return {
      socketRunning: false,
      announcements: [],
      intervalMessage: null,
      csInterval: null,
      noServiceLimitTime: 60 * 1000,
      callCSTimer: null,
      streamIndex: 0,
      streamDataFormate: [],
      streamingIn: false,
      dt: 10,
      testMessages: '',
      noconnectionType: 'network',
      ip: "",
      position: "",
      lastId: 0,
      lastSendMessageTime: new Date().getTime(),
      updateTime: new Date().getTime(),
      timer: "",
      logoutTimer: "",
      showWelcome: false,
      show_activebtnPage: false,
      show_noconnection: false,
      publisher: ["me", "bot", "human"],
      html: "",
      alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
      messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
      historyMessageList: [],
      newMessagesCount: 0,
      isChatOpen: true, // to determine whether the chat window should be open or closed
      showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
      customizedStyle: {},
      r: '',
      isHistoryMode: false, // true :: show history chats . default is false,
      showHistoryBar: false,
      waitServiceType: 'default',
      gameNumber: 0
    }
  },
  computed: {
    showClientMessages() {
      return this.isHistoryMode ? this.historyMessageList : this.messageList
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)

    if (this.callCSTimer) {
      clearInterval(this.callCSTimer)
    }
  },
  mounted() {
    // 20200115 測試 APP 模組
    if (this.appModule_conversation_id !== "") {
      // sessionStorage.setItem("immediacy_time",immediacy_time);
      sessionStorage.setItem("conversation_id", this.appModule_conversation_id)
    }

    // if (sessionStorage.getItem('client_id') === null) {
    //   // console.log('client_id 0 : 產生 uuid')
    //   sessionStorage.setItem('client_id', uuid.v1())
    // }

    handle_pinch_hand()
    this.getBulletinContent()
    // 動態匯入 CSS 檔
    let styleFile = 'styleEdit_' + this.projectId
    import('../../../static/styles/' + styleFile + '.css').then(() => {
    }).catch((error) => {
      console.log('Error CSS : ' + '@/components/beautiful-chat/styles/' + styleFile + '.css')
    })
  },
  methods: {
    closeGamePopup() {
      this.gameNumber = 0
    },
    setInfoMessage(text) {
      let message = {
        type: 'takeOverMessage',
        author: 'bot',
        data: {
          text: text
        },
        msgJson: null,
        requestTime: Math.floor(new Date().getTime() / 1000)
      }
      this.messageList = [...this.messageList, message]
    },
    goSocket() {
      let data = {
        conversation_id: sessionStorage.getItem("conversation_id"),
        user_client_id: sessionStorage.getItem('client_id'),
        user_id: sessionStorage.getItem('uid')
      }
      this.$socket.emit('user_request_join', data)
      if (!this.socketRunning) {
        this.subscribeSocketEvent()
      }
    },
    subscribeSocketEvent() {

      clearInterval(this.timer)
      // user_send_msg
      this.sockets.subscribe('user_send_msg', (data) => {
        // console.log(data)
      })
      // connect
      this.sockets.subscribe('connect', (data) => {
        console.log('connect')
      })
      // disconnect
      this.sockets.subscribe('disconnect', (data) => {
        this.timer = setInterval(this.getApi, 10000)
      })

      // cs_close_case
      this.sockets.subscribe('cs_close_case', (data) => {
        const myConversationId = sessionStorage.getItem('conversation_id')
        const info = JSON.parse(data)
        if (myConversationId && (myConversationId === info.conversation_id)) {
          this.closeCaseEvent()
        }
      })

      // cancel_call
      this.sockets.subscribe('cancel_call', (data) => {
        this.cancelCallHuman(data)
      })

      // user_call
      this.sockets.subscribe('user_call', (data) => {
        this.waitServiceType = 'checkCallCsAgin'
        this.waitingForService(data, 60000)
      })

      // user_join
      this.sockets.subscribe('user_join', (data) => {
        // console.log('user_join')
      })

      // cs_under_control
      this.sockets.subscribe('cs_under_control', (data) => {
        console.log("目前為專人回覆")

        if (this.callCSTimer) {
          clearInterval(this.callCSTimer)
        }
        // Add cs tag
        this.intervalMessage.data.text = '目前為專人回覆'
        clearInterval(this.csInterval)
        this.csInterval = null
      })

      // bot_under_control
      this.sockets.subscribe('bot_under_control', (data) => {
        if (this.callCSTimer) {
          clearInterval(this.callCSTimer)
        }
        // Add bot tag
        const botMessage = {
          type: 'takeOverMessage',
          author: 'bot',
          data: {
            text: '目前為機器人回覆'
          },
          msgJson: null,
          requestTime: Math.floor(new Date().getTime() / 1000)
        }
        console.log("目前為機器人回覆")
        // 因時間差問題，延遲顯示，效果比較好
        setTimeout(() => {
          this.messageList = [...this.messageList, botMessage]
        }, 1000)
      })

      // cs_send_msg
      this.sockets.subscribe('cs_send_msg', (data) => {
        this.handle_logoutTimer(sessionStorage.getItem("immediacy_time"), false)
        console.log('cs_send_msg')

        this.getApi()
      })


      // text_streaming_start
      this.sockets.subscribe('text_streaming_start', (data) => {
        this.streamDataFormate[this.streamIndex] = {
          type: "mark",
          author: "bot",
          data: {
            text: ""
          },
          msgJson: null,
          requestTime: Math.floor(new Date().getTime() / 1000)
        }
        this.messageList = [...this.messageList, this.streamDataFormate[this.streamIndex]]
      })

      // text_streaming_end
      this.sockets.subscribe('text_streaming_end', (data) => {
        setTimeout(() => {
          this.streamingIn = false
          this.streamIndex++
          this.dt = 10
          $('.sc-message-list').animate({
            scrollTop: $('.sc-message-list')[0].scrollHeight
          }, 'slow')
        }, 1000)
        this.handle_logoutTimer(sessionStorage.getItem("immediacy_time"), false)
      })

      // text_streaming
      this.sockets.subscribe('text_streaming', (data) => {
        const d = JSON.parse(data)
        this.onStreamMessageReceived(d.message)
      })

      this.socketRunning = true
    },
    showHistoryMode(value) {
      this.isHistoryMode = value
    },
    handleWebSocket() {

      // 20190701
      console.log('20190702 1')
      //使用 WebSocket 的網址向 Server 開啟連結
      var ws = new WebSocket('wss://7wq6fucfk4.execute-api.us-east-1.amazonaws.com/Prod')
      console.log('20190702 2')
      //開啟後執行的動作，指定一個 function 會在連結 WebSocket 後執行
      ws.onopen = () => {
        console.log('open connection')
        //emit join room action 

        joinRoomAction()
      }

      //關閉後執行的動作，指定一個 function 會在連結中斷後執行
      ws.onclose = () => {
        console.log('close connection')
      }
      //接收Message From Server
      ws.onmessage = event => {
        console.log('recive server event=', event)
        this.handle_logoutTimer(sessionStorage.getItem("immediacy_time"), false)
        this.getApi()
      }

      //join room action 
      function joinRoomAction() {
        console.log('joinRoomAction')
        ws.send('{ "action" : "joinRoom", "conversationID" : "cvid123", "userType" : "User", "projectId" : "999" }')
      }

      function leaveRoomAction() {
        console.log('leaveRoomAction')
        ws.send('{ "action" : "leaveRoom", "conversationID" : "cvid123", "userType" : "User", "projectId" : "999" }')
      }

      function reconnectAction() {
        console.log('reconnectAction')
        ws = new WebSocket('wss://7wq6fucfk4.execute-api.us-east-1.amazonaws.com/Prod')
      }

      function disconnectAction() {
        console.log('disconnectAction')
        ws.close()
      }

      function sendMessageAction() {
        console.log('sendMessageAction')
        ws.send('{ "action" : "user_send_msg", "conversationID" : "cvid123", "userType" : "User", "projectId" : "999" , "userId" : "uid789" }')
      }

    },
    async getBulletinContent() {
      try {
        const response = await getAnnouncement(this.projectId)
        this.announcements = response.data
      } catch (error) {
        console.log(error + '無法取得公告')
      }
    },
    async getHistoryChat() {
      try {
        const response = await getUserHistoryChats(this.projectId)
        const res = response.data
        if (res.data.length !== 0) {
          // 關閉 30 天對話
          this.showHistoryBar = true
        }
        res.data.forEach(element => {
          let data = {}
          data.id = element.id
          data.type = element.msg_type == 0 ? "text" : "rich"
          data.author = this.publisher[element.publisher_type]
          data.data = { text: element.msg_text }
          data.msgJson = element.msg_json
          data.requestTime = element.request_time
          if (data.msgJson != null && data.msgJson != undefined && (JSON.stringify(JSON.parse(data.msgJson).msgType)) == '\"multiple\"') {
            data = this.handle_multiple(data)
          } else {
            this.historyMessageList = [...this.historyMessageList, data]
          }
        })
      }
      catch (error) {
        console.log(error)
        console.log('網路異常，訊息接收失敗 Rooms')
        this.historyMessageList = []
      }
    },
    async getApi() {
      console.log('Rooms get chats from socket')

      let params
      if (this.lastId !== 0) {
        params = { after_id: this.lastId }
      }
      try {
        const response = await getChats(params, sessionStorage.getItem('conversation_id'), this.projectId)
        // console.log(res)

        const res = response.data
        this.lastId = res.last_id == null ? this.lastId : res.last_id
        res.data.forEach(element => {
          let data = {}
          data.id = element.id
          data.type = element.msg_type == 0 ? "text" : "rich"
          data.author = this.publisher[element.publisher_type]
          data.data = { text: element.msg_text }
          data.msgJson = element.msg_json
          data.requestTime = element.request_time
          if (data.msgJson != null && data.msgJson != undefined && (JSON.stringify(JSON.parse(data.msgJson).msgType)) == '\"multiple\"') {
            data = this.handle_multiple(data)
          } else {
            this.messageList = [...this.messageList, data]
          }
        })
        const lastMessage = this.messageList[this.messageList.length - 1].requestTime
        this.updateTime = lastMessage * 1000
      }
      catch (error) {
        console.log(err)
        console.log('網路異常，訊息接收失敗 Rooms')
        sessionStorage.setItem("immediacy_time", "undefine")
        sessionStorage.removeItem("conversation_id")
        localStorage.removeItem("close_widget")
        this.messageList = []
        this.handle_show_noconnection(true, 'defalut')
      }
    },
    handle_multiple(data) {

      // 重點 ---------------------------------------------------
      if (data.msgJson != null && data.msgJson != undefined) {
        if ((JSON.stringify(JSON.parse(data.msgJson).msgType)) == '\"multiple\"') {
          // console.log('20191223 : ' + JSON.stringify(JSON.parse(data.msgJson).msgType))
          // 暫存 multiple 的資料
          // let temp = JSON.parse(data.msgJson)
          let temp = data
          for (let j = 0; j < JSON.parse(temp.msgJson).msgList.length; j++) {

            var y = new String(JSON.stringify(JSON.parse(temp.msgJson).msgList[j]).replace(new RegExp('(["\"])', 'g'), "\\\""))

            let setMultiple = {}
            setMultiple.id = temp.id
            setMultiple.type = temp.type
            setMultiple.author = temp.author
            setMultiple.data = JSON.stringify(temp.data)
            setMultiple.msgJson = JSON.stringify(JSON.parse(temp.msgJson).msgList[j])
            setMultiple.requestTime = temp.requestTime
            if (j == 0) {
              setMultiple.head_and_time = 0
            } else if ((j + 1) == (JSON.parse(temp.msgJson).msgList.length)) {
              setMultiple.head_and_time = 1
            } else {
              setMultiple.head_and_time = 2
            }
            // this.testMessages.splice( i, j === 0 ? 1 : 0, JSON.parse(setMultiple))
            // console.log('20191223 : ' + JSON.stringify(setMultiple))
            this.messageList = [...this.messageList, setMultiple]
          }
        }
      }
    },
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1
      }
    },
    tagClicked(value) {

  

      if (value.includes('ccbot-login')) {
        postMessage('ccbot-login')
        const ev = value.split('|')
        if (ev.length > 1 && ev[1] !== '') {
          this.$store.commit('SET_LOGIN_RESPONSE', ev[1])
        }
        return
      }

      const data = {}
      data.type = "text"
      data.author = "me"
      data.data = { text: value }
      data.msgJson = null

      this.onMessageWasSent(data)
    },
    async onStreamMessageReceived(message) {

      if (this.streamingIn) {
        // this.dt += 30
        this.streamDataFormate[this.streamIndex].data.text += message
      }
    },
    async onMessageWasSent(message) {
      // 發送訊息

      const userData = {
        conversation_id: sessionStorage.getItem("conversation_id")
      }
      if (userData.conversation_id) {
        if (message.data.text === `WAITING-SERVICE-30-SECOND`) {
          if (this.waitServiceType === 'checkCallCsAgin') {
            this.waitingForService(JSON.stringify(userData), 30000)
            this.waitServiceType = 'default'
          }
          return
        } else if (message.data.text === `CANCEL-SERVICE-30-SECOND`) {
          this.waitServiceType = 'default'
          // let data = {
          //   conversation_id: sessionStorage.getItem("conversation_id"),
          //   user_client_id: sessionStorage.getItem('client_id'),
          //   user_id: sessionStorage.getItem('uid')
          // }
          // this.cancelCallHuman(JSON.stringify(data))
          return
        }
      }

      // 移除 html tag
      this.delHtmlTag(message.data.text)
      // 移除 空白後檢查是否有文字
      if (message.data.text.trim() == '') {
        return false
      }

      var client_gps = ''
      if (localStorage.getItem('GPSLocationData') != null && localStorage.getItem('GPSLocationData') != '') {
        client_gps = localStorage.getItem('GPSLocationData')
      } else if (localStorage.getItem('Longitude') != null) {
        //20190801 測試抓取經緯度
        // getLatitudeAndLongitude();
        client_gps = localStorage.getItem('Latitude') + ',' + localStorage.getItem('Longitude')
      } else { }

      if (this.lastSendMessageTime > new Date().getTime() - 2000 && this.messageList.length > 0) {

        // alert("發送訊息太密集"); // 原訊息視窗，會顯示網址，故不採用
        customMessage(this.isMobile, 'alert', '我是標題', '發送訊息太密集')
        // customMessage(this.isMobile, 'confirm', '我是標題', '發送訊息太密集');
        return
      }
      this.lastSendMessageTime = new Date().getTime()
      message.requestTime = Math.floor(new Date().getTime() / 1000)
      this.messageList = [...this.messageList, message]
      if (this.messageList.length === 1) {
        const botMessage = {
          type: 'takeOverMessage',
          author: 'bot',
          data: {
            text: '目前為機器人回覆'
          },
          msgJson: null,
          requestTime: Math.floor(new Date().getTime() / 1000)
        }
        this.messageList = [...this.messageList, botMessage]
      }
      let json
      if (client_gps == '') {
        // 抓不到 GPS 就不傳此參數
        json = {
          msg_text: message.data.text,
          after_id: this.lastId
        }
      } else {
        json = {
          msg_text: message.data.text,
          after_id: this.lastId,
          client_gps: client_gps
        }
      }

      // 平台資料
      var platform_data = ''

      // 平台資料設定
      if (this.isApp == true) {
        // app
        platform_data = platform_data + 'app_'
        if (this.device == 'android') {
          platform_data = platform_data + 'android_'
        } else if (this.device == 'iphone') {
          platform_data = platform_data + 'ios_'
        } else {
          platform_data = 'web_desktop_'
        }
        platform_data = platform_data + this.platform_param

      } else {
        // device
        platform_data = platform_data + 'web_'
        if (this.device == 'android') {
          platform_data = platform_data + 'mobile_'
        } else if (this.device == 'iphone') {
          platform_data = platform_data + 'mobile_'
        } else {
          platform_data = 'web_desktop_'
        }
        platform_data = platform_data + this.platform_param

      }
      // 平台資料設定
      json.client_platform = platform_data

      if (sessionStorage.getItem("conversation_id")) {
        json.conversation_id = sessionStorage.getItem("conversation_id")
      } else {
        json.client_lang = navigator.language
        json.client_ip = this.ip.trim()
        if (this.position !== "" && this.position.length > 0) {
          json.client_position = this.position
        }
      }
      json.client_id = sessionStorage.getItem('client_id')
      try {


        let response = await chats(json, this.projectId)

        // 最後一次對話的 id，用來判斷如何接續資料
        this.lastId =
          response.last_id == null ? this.lastId : response.last_id
        if (response.data) {
          const res = response.data
          if (
            !sessionStorage.getItem("conversation_id") ||
            sessionStorage.getItem("conversation_id") === "undefine"
          ) {
            sessionStorage.setItem("conversation_id", res.data[res.data.length - 1].conversation_id)
            this.goSocket()
          }

          this.handle_logoutTimer(sessionStorage.getItem("immediacy_time"), false)
          this.lastId = res.last_id
          let currentId = res.current_id
          res.data.forEach(element => {
            let data = {}
            data.id = element.id
            data.type = element.msg_type == 0 ? "text" : "rich"
            data.author = this.publisher[element.publisher_type]
            data.data = { text: element.msg_text }
            data.msgJson = element.msg_json
            data.requestTime = element.request_time
            let checkMulti = false
            const msgJson = JSON.parse(data.msgJson)
            if (currentId != data.id) {
              if (msgJson
                && msgJson.msgType === 'multiple') {
                data = this.handle_multiple(data)
              } else if (msgJson
                && msgJson.msgType === 'waitingTextStream') {
                this.streamingIn = true
              } else {
                this.messageList = [...this.messageList, data]
              }
            }
          })
        }
      } catch (error) {
        console.log(error)
        console.log('網路異常，訊息發送失敗')
        sessionStorage.setItem("immediacy_time", "undefine")
        sessionStorage.removeItem("conversation_id")
        this.messageList = []

        // 網路異常時要顯示離線頁 --------------
        this.handle_show_noconnection(true, 'defalut')
      }
    },
    delHtmlTag(str) {
      return str.replace(/<[^>]+>/g, "")// 移除所有的 html tag
    },
    openChat() {

      // 傳訊息給父頁面 -----------------------------------------------------
      postMessage('open')

      setTimeout(() => {
        // console.log('test ' + sessionStorage.getItem("conversation_id"))
        if ((!sessionStorage.getItem("conversation_id") || sessionStorage.getItem("conversation_id") === "undefine")
          && this.messageList.length == 0) {
          this.showWelcome = true
        } else {
          this.showWelcome = false
        }
        // called when the user clicks on the fab button to open the chat
        this.isChatOpen = true
        this.newMessagesCount = 0

      }, 50)

    },
    closeCaseEvent() {
      sessionStorage.setItem("immediacy_time", "undefine")
      sessionStorage.removeItem("conversation_id")
      localStorage.removeItem("close_widget")
      this.announcements = []
      this.appModule_conversation_id = ""
      this.messageList = []
      this.showWelcome = true
      this.show_activebtnPage = true
      this.showHistoryBar = false // 隱藏 history bar
      this.isHistoryMode = false // 關閉 history mode
      clearInterval(this.logoutTimer)
      this.logoutTimer = null
      clearInterval(this.timer)
      this.timer = null
    },
    closeChat(jsonString) {
      if (this.messageList.length > 0) {
        var r = customMessage(this.isMobile, 'confirm', '我是標題', '是否關閉對話?')
          .then((value) => {
            if (value == true) {
              // this.announcements = []
              const data = {
                conversation_id: sessionStorage.getItem("conversation_id"),
                user_client_id: sessionStorage.getItem('client_id'),
                user_id: sessionStorage.getItem('uid'),
                'status': 2
              }
              // when leave the chat, we need to tell the server to remove the user from the users list
              this.$socket.disconnect()
              sessionOver(data, this.projectId)
              if (this.isApp) {
                mobileClose(this.device, jsonString)
              } else {
                // 執行電腦版的關閉方法

                postMessage('close')
                setTimeout(() => {
                  // 移除 firebase token
                  this.$store.commit('SET_FIREBASE_TOKEN', null)
                }, 200)
              }

              setTimeout(() => {
                // 20190622 拆開後一直保持開啟的狀態
                // this.isChatOpen = false;
                // 新增登出時要做的事
                sessionStorage.setItem("immediacy_time", "undefine")
                sessionStorage.removeItem("conversation_id")
                sessionStorage.removeItem("client_id")
                localStorage.removeItem("close_widget")
                this.messageList = []
                clearInterval(this.logoutTimer)
                this.logoutTimer = null
                clearInterval(this.timer)
                this.timer = null
                if (this.callCSTimer) {
                  clearInterval(this.callCSTimer)
                  this.callCSTimer = null
                }
                this.show_noconnection = false // 離線畫面
                this.showWelcome = true // 歡迎頁面
                this.show_activebtnPage = false // 重啟頁面
                this.isHistoryMode = false

                localStorage.removeItem('conversation_list')
              }, 300)
            }
          })
          .catch(function (error) {
            console.log('20191115 B ' + error)
          })

      } else {
        if (this.isApp) {
          mobileClose(this.device, "")
        } else {
          // 執行電腦版的關閉方法
          postMessage('close')
        }

      }

    },
    minifyChat() {
      // 20200326 其軒通知 ios 平板辨識以為是PC
      // if (this.isApp && this.device !== 'pc') {
      if (this.isApp) {
        mobileClose(this.device, "")
      } else {
        // 執行電腦版的關閉方法
        postMessage('close', this.messageList)
      }
    },
    returnJSONtoMobile(jsonString) {
      if (jsonString !== '') {
        // 傳參數回 APP
        // 20200326 其軒通知 ios 平板辨識以為是PC
        // if (this.isApp && this.device !== 'pc') {
        if (this.isApp) {
          mobileClose(this.device, jsonString)
        } else {
          // 執行電腦版的關閉方法
          postMessage('close')
        }
      } else {
        // 空的就不動作
      }
    },
    handle_logoutTimer(immediacy_time, first) {
      if (first && this.appModule_conversation_id == "") {
        sessionStorage.setItem("immediacy_time", immediacy_time)
        this.tagClicked('開始吧')
      } else if (first && this.appModule_conversation_id !== "") {
        sessionStorage.setItem("immediacy_time", immediacy_time)
        this.getApi()
      }
      if (sessionStorage.getItem("conversation_id") && sessionStorage.getItem("conversation_id") !== "undefine") {

        // 每一次發話或接收訊息，都更新資料
        var set_json_conversation_list =
          '{"conversation_list":[{"conversation_id":"' +
          sessionStorage.getItem("conversation_id") +
          '","end_time":' +
          // Math.floor((new Date().getTime() / 1000) + (10)) +'}]}'
          Math.floor((new Date().getTime() / 1000) + (immediacy_time / 1000)) + '}]}'
        localStorage.setItem('conversation_list', set_json_conversation_list)

      }

      clearInterval(this.logoutTimer)
      this.logoutTimer = null

      // 登出執行的部分
      this.logoutTimer = setInterval(() => {
        this.socketRunning = false
        this.announcements = []
        const data = {
          conversation_id: sessionStorage.getItem("conversation_id"),
          user_client_id: sessionStorage.getItem('client_id'),
          user_id: sessionStorage.getItem('uid'),
          'status': 3
        }
        sessionOver(data, this.projectId)
        sessionStorage.setItem("immediacy_time", "undefine")
        sessionStorage.removeItem("conversation_id")
        sessionStorage.removeItem("client_id")
        localStorage.removeItem("close_widget")
        this.gameNumber = 0
        this.appModule_conversation_id = ""
        this.messageList = []
        this.showWelcome = true
        this.show_activebtnPage = true
        this.showHistoryBar = false // 隱藏 history bar
        this.isHistoryMode = false // 關閉 history mode
        clearInterval(this.logoutTimer)
        this.logoutTimer = null
        clearInterval(this.timer)
        if (this.callCSTimer) {
          clearInterval(this.callCSTimer)
          this.callCSTimer = null
        }
        this.timer = null
      }, sessionStorage.getItem("immediacy_time"))
    },
    // 關閉 welcome
    handle_showWelcome() {
      this.showWelcome = false
      // 是否關閉 30 天歷史記錄
      if (this.showHistoryBar) {
        this.getHistoryChat()
      }
    },
    // 關閉 重啟畫面
    handle_show_activebtnPage() {
      this.show_activebtnPage = false
    },
    // 關閉 離線畫面
    handle_show_noconnection(show, type) {
      this.appModule_conversation_id = ""

      clearInterval(this.logoutTimer)
      this.logoutTimer = null

      clearInterval(this.timer)
      this.timer = null

      if (show) {
        // 沒網路
        if (type) {
          this.noconnectionType = type
        }
        this.show_noconnection = true
        this.showWelcome = false
      } else {
        // 有網路
        sessionStorage.setItem("immediacy_time", "undefine")
        sessionStorage.removeItem("conversation_id")
        localStorage.removeItem("close_widget")
        this.messageList = []
        this.show_noconnection = false
        this.showWelcome = true
      }
    },
    myIP() {
      return new Promise(async (resolve, reject) => {
        const res = await this.axios.get("http://api.hostip.info/get_html.php")
        const data = res.data.split("IP:")[1]
        resolve(data)
      })
    },
    checkCallCsAgin() {
      return JSON.stringify({
        cards: [
          {
            buttons: [
              { payload: '轉接專人客服', title: '繼續等待', actionType: 'text' },
              { payload: '取消轉接專人', title: '取消轉接專人', actionType: 'text' },
            ],
            text: '客服人員忙線中，是否繼續等待?'
          }],
        direction: 'h',
        msgType: 'textCards'
      })
    },
    // checkCallCsAgin() {
    //   return JSON.stringify({
    //     cards: [
    //       {
    //         buttons: [
    //           { payload: 'WAITING-SERVICE-30-SECOND', title: '繼續等待', actionType: 'text' },
    //           { payload: 'CANCEL-SERVICE-30-SECOND', title: '取消轉接專人', actionType: 'text' },
    //         ],
    //         text: '客服人員忙線中，是否繼續等待?'
    //       }],
    //     direction: 'h',
    //     msgType: 'textCards'
    //   })
    // },
    noServiceNow() {
      return JSON.stringify({
        msgType: 'html',
        html: "線上客服人員忙線中，請改至網站中【 <a href='https://tickets.udnfunlife.com/application/UTK13/UTK1311_.aspx' target='_blank'>線上留言</a> 】，我們將於您留言後3個工作日內儘快回覆給您，謝謝。"
      })
    },
    sendNoCSMessage() {
      const message = {}
      message.type = "rich"
      message.author = "bot"
      if (this.waitServiceType === 'checkCallCsAgin') {
        message.msgJson = this.checkCallCsAgin()

      } else {
        message.msgJson = this.noServiceNow()
      }


      message.requestTime = Math.floor(new Date().getTime() / 1000)
      this.messageList = [...this.messageList, message]
      clearInterval(this.callCSTimer)
      // this.callCSTimer = null 可以再次呼叫客服計時器，若不加則一次對話只能呼叫客服一次
      this.callCSTimer = null
    },
    waitingForService(data, sec) {
      setTimeout(() => {
        // 使用者呼叫客服
        const myConversationId = sessionStorage.getItem('conversation_id')
        const info = JSON.parse(data)
        if (myConversationId && (myConversationId === info.conversation_id)) {
          if (!this.callCSTimer) {

            this.callCSTimer = setTimeout(this.sendNoCSMessage, sec)
          }
          if (!this.csInterval) {
            let intervalAllTime = sec / 1000
            this.intervalMessage = {
              type: 'takeOverMessage',
              author: 'bot',
              data: {
                text: `已轉接客服人員請稍候...${intervalAllTime}s`
              },
              msgJson: null,
              requestTime: Math.floor(new Date().getTime() / 1000)
            }
            setTimeout(() => {
              this.messageList = [...this.messageList, this.intervalMessage]
            }, 500)

            this.csInterval = setInterval(() => {
              if (intervalAllTime === 1) {
                this.intervalMessage.data.text = `專人客服忙線中`
                clearInterval(this.csInterval)
                this.csInterval = null
                const data = {
                  conversation_id: myConversationId
                }
                changeCallHumanStatus(data, this.projectId)
              } else {
                this.intervalMessage.data.text = `已轉接客服人員請稍候...${--intervalAllTime}s`
              }
            }, 1000)
          }
        }
      }, 1000)
    },
    cancelCallHuman(data) {
      // 停止呼叫客服
      const myConversationId = sessionStorage.getItem('conversation_id')
      const info = JSON.parse(data)
      if (myConversationId && (myConversationId === info.conversation_id)) {
        this.intervalMessage.data.text = `取消轉接`
        clearInterval(this.callCSTimer)
        clearInterval(this.csInterval)
        this.csInterval = null
        this.callCSTimer = null
        const data = {
          conversation_id: myConversationId
        }
        changeCallHumanStatus(data, this.projectId)
      }
    }
  },
  sockets: {
    connect() {
      clearInterval(this.timer)
      // socket 正常運作，清除 timer
      // const url = window.location.hash.split('#/')[1]
      // console.log( `${process.env.SOCKET_API}ccbot-${url}`)
    },
    disconnect() {
      // socket 連線異常，啟動 timer
      this.timer = setInterval(this.getApi, 10000)
    },
    cs_close_case(data) {
      // 客服結束案件
      const myConversationId = sessionStorage.getItem('conversation_id')
      const info = JSON.parse(data)
      if (myConversationId && (myConversationId === info.conversation_id)) {
        this.closeCaseEvent()
      }
    },
    cancel_call(data) {
      // alert('1')
      // 停止呼叫客服
      this.cancelCallHuman(data)
    },

    user_call(data) {
      if (this.projectId === 'eip') {
        console.log(' U寶 : ❓❓❓ ')
        return
      }
      this.waitServiceType = 'checkCallCsAgin'
      this.waitingForService(data, 60000)

    },
    user_join(data) {
      // const botMessage = {
      //   type: 'takeOverMessage',
      //   author: 'bot',
      //   data: {
      //     text: '目前為機器人回覆'
      //   },
      //   msgJson: null,
      //   requestTime: Math.floor(new Date().getTime() / 1000)
      // }
      // this.messageList = [...this.messageList, botMessage]
    },
    cs_under_control(data) {
      // alert('切換為客服')
      if (this.callCSTimer) {
        clearInterval(this.callCSTimer)
      }
      // Add cs tag
      this.intervalMessage.data.text = '目前為專人回覆'
      clearInterval(this.csInterval)
      this.csInterval = null
      // const csMessage = {
      //   type: 'takeOverMessage',
      //   author: 'me',
      //   data: {
      //     text: '目前為專人回覆'
      //   },
      //   msgJson: null,
      //   requestTime: Math.floor(new Date().getTime() / 1000)
      // }
      // setTimeout(() => {
      //   this.messageList = [...this.messageList, csMessage]
      // }, 1000)
    },
    bot_under_control(data) {
      // alert('切換為機器人')
      if (this.callCSTimer) {
        clearInterval(this.callCSTimer)
      }
      // Add bot tag
      const botMessage = {
        type: 'takeOverMessage',
        author: 'bot',
        data: {
          text: '目前為機器人回覆'
        },
        msgJson: null,
        requestTime: Math.floor(new Date().getTime() / 1000)
      }

      // 因時間差問題，延遲顯示，效果比較好
      setTimeout(() => {
        this.messageList = [...this.messageList, botMessage]
      }, 1000)
    },
    cs_send_msg(data) {
      // console.log(data)
      // console.log("socket fire")
      this.handle_logoutTimer(sessionStorage.getItem("immediacy_time"), false)
      this.getApi()
    },
    text_streaming_start() {
      this.streamDataFormate[this.streamIndex] = {
        type: "mark",
        author: "bot",
        data: {
          text: ""
        },
        msgJson: null,
        requestTime: Math.floor(new Date().getTime() / 1000)
      }
      this.messageList = [...this.messageList, this.streamDataFormate[this.streamIndex]]
    },
    text_streaming_end(v) {
      setTimeout(() => {
        this.streamingIn = false
        this.streamIndex++
        this.dt = 10
        $('.sc-message-list').animate({
          scrollTop: $('.sc-message-list')[0].scrollHeight
        }, 'slow')
      }, 1000)
      this.handle_logoutTimer(sessionStorage.getItem("immediacy_time"), false)
    },
    text_streaming(sd) {
      const d = JSON.parse(sd)
      this.onStreamMessageReceived(d.message)
    },
    text_streaming_error(v) {
      setTimeout(() => {
        this.streamDataFormate[this.streamIndex] = {
          type: "mark",
          author: "bot",
          data: {
            text: '這個問題很好，容我休息思考一段時間。'
          },
          msgJson: null,
          requestTime: Math.floor(new Date().getTime() / 1000)
        }
        this.messageList = [...this.messageList, this.streamDataFormate[this.streamIndex]]

        this.streamingIn = false
        this.streamIndex++
        this.dt = 10
        $('.sc-message-list').animate({
          scrollTop: $('.sc-message-list')[0].scrollHeight
        }, 'slow')
      }, 2000)
      this.handle_logoutTimer(sessionStorage.getItem("immediacy_time"), false)
    }
  }
}
</script>

<style>
.chat {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background: no-repeat center center fixed;
  background-color: transparent;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/chatroom/Rooms.vue